/**
 * DevModeBanner Component
 * 
 * Shows a non-intrusive banner when the app is running in development mode
 * with mock authentication (no Clerk key provided).
 */

import React, { useState } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { IS_DEV_MODE } from '@/app/providers/AuthProvider';

export function DevModeBanner() {
  const [isVisible, setIsVisible] = useState(true);

  // Don't show banner in production mode
  if (!IS_DEV_MODE || !isVisible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-amber-50 border-b border-amber-200 px-4 py-2 shadow-sm" style={{ zIndex: 100 }}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-amber-800 text-sm">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <span className="font-medium">
            Development mode: using mock authentication
          </span>
          <span className="text-amber-600 hidden sm:inline">
            (Set VITE_CLERK_PUBLISHABLE_KEY to enable real auth)
          </span>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-amber-600 hover:text-amber-800 transition-colors p-1 hover:bg-amber-100 rounded"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}